import { BrowserModule} from '@angular/platform-browser';
import { NgModule, Injectable, Injector, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SignupComponent } from './auth/signup/signup.component';
import { SigninComponent } from './auth/signin/signin.component';
import { AuthService } from './services/auth.service';
import { AuthGuardService } from './services/auth-guard.service';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { ProfilComponent } from './user/profil/profil.component';
import { ServiceComponent } from './user/service/service.component';
import { AdminComponent } from './user/admin/admin.component';
import { AdminGuardService } from './services/admin-guard.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LoadpageComponent } from './loadpage/loadpage.component';
import { NgChartjsModule } from 'ng-chartjs';
import { TestComponent } from './charts/test/test.component';
import { BarComponent } from './charts/bar/bar.component';
import { ChartsModule } from 'ng2-charts';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { NoopAnimationsModule, BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSliderModule} from '@angular/material/slider';
import {createCustomElement} from '@angular/elements'
import { ColorPickerModule } from 'ngx-color-picker';
import { RecaptchaModule } from 'ng-recaptcha';
import {MatMenuModule} from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatDatepickerModule } from '@angular/material/datepicker';
import { ResizableModule } from 'angular-resizable-element';
import { PrestashopService } from './services/prestashop.service';
import { GraphService } from './services/graph.service';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { BlockComponent } from './block/block.component';
import { MatNativeDateModule } from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import { DatePipe } from '@angular/common'


const appRoutes : Routes = [
  {path: 'auth/signup', component: SignupComponent},
  {path: 'auth/signin', component: SigninComponent},
  {path: 'user/profil',canActivate: [AuthGuardService], component: ProfilComponent},
  {path: 'user/service',canActivate: [AuthGuardService], component: ServiceComponent},
  {path: 'user/admin',canActivate: [AdminGuardService], component: AdminComponent, },
  {path: 'home',canActivate: [AuthGuardService], component: HomeComponent},
  {path: 'loadpage',canActivate: [AuthGuardService], component: LoadpageComponent},
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: 'home' }
]


@NgModule({
  declarations: [
    AppComponent,
    SignupComponent,
    SigninComponent,
    HeaderComponent,
    HomeComponent,
    ProfilComponent,
    ServiceComponent,
    AdminComponent,
    LoadpageComponent,
    TestComponent,
    BarComponent,
    BlockComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule, 
    ReactiveFormsModule,
    HttpClientModule,
    FontAwesomeModule,
    RouterModule.forRoot(appRoutes),
    DragDropModule,
    NgChartjsModule,
    ChartsModule,
    MatSliderModule,
    BrowserAnimationsModule,
    ColorPickerModule,
    ResizableModule,
    RecaptchaModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatSelectModule,
    MatDialogModule
  ],
  entryComponents: [
    TestComponent,
    BarComponent,
    HomeComponent
  ],
  providers: [
    AuthService,
    AuthGuardService,
    PrestashopService,
    GraphService,
    MatDatepickerModule,
    MatNativeDateModule,
    DatePipe
  ],

  exports: [
    TestComponent,
    MatMenuModule,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector : Injector){
    const test = createCustomElement(TestComponent, {injector : injector})
    customElements.define('test-graph',test);
    const bar = createCustomElement(BarComponent, {injector : injector})
    customElements.define('bar-graph', bar);
  }
 }
